import axios from 'axios';
import { getHeaders } from '../utility/getHeader';

/**
 * HR Analytics API Service
 * Handles all API calls for HR Analytics Dashboard
 */

/**
 * Get comprehensive HR Analytics Dashboard Summary
 */
export const getHRDashboardSummary = async () => {
  try {
    const response = await axios.get('/hr/dashboard-summary', getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching HR dashboard summary:', error);
    throw error;
  }
};

/**
 * Get department-wise employee distribution
 */
export const getDepartmentDistribution = async () => {
  try {
    const response = await axios.get('/hr/department-distribution', getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching department distribution:', error);
    throw error;
  }
};

/**
 * Get attendance trends for a date range
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 */
export const getAttendanceTrends = async (startDate, endDate) => {
  try {
    const response = await axios.post(
      '/hr/attendance-trends',
      { startDate, endDate },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching attendance trends:', error);
    throw error;
  }
};

/**
 * Get payroll summary by month/year
 * @param {string} month - Month (optional)
 * @param {string} year - Year (optional)
 */
export const getPayrollSummary = async (month = null, year = null) => {
  try {
    const response = await axios.post(
      '/hr/payroll-summary',
      { month, year },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching payroll summary:', error);
    throw error;
  }
};

/**
 * Get attendance records for a specific employee
 * @param {number} employeeId - Employee ID
 * @param {string} startDate - Start date (optional)
 * @param {string} endDate - End date (optional)
 */
export const getEmployeeAttendance = async (employeeId, startDate = null, endDate = null) => {
  try {
    const response = await axios.post(
      '/hr/employee-attendance',
      { employeeId, startDate, endDate },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching employee attendance:', error);
    throw error;
  }
};

/**
 * Get recent audit logs
 * @param {number} limit - Number of logs to retrieve (default: 50)
 */
export const getAuditLogs = async (limit = 50) => {
  try {
    const response = await axios.get(`/hr/audit-logs?limit=${limit}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching audit logs:', error);
    throw error;
  }
};
